import { styled } from '@mui/material';

const minFundColWidth = 300;

export const CaptableGridContainer = styled('div')`
  .type-header,
  .type-header:hover {
    background-color: ${({ theme }) => theme.colors.primary[10]} !important;
  }
  .total-header .ag-header-cell-comp-wrapper {
    justify-content: center;
  }
  .investment-header,
  .investment-header:hover {
    background-color: ${({ theme }) => theme.colors.primary[5]} !important;
  }

  .ag-header-group-cell.ag-header-group-cell-with-group.type-header {
    border-top: 1px solid transparent;
  }
  .ag-popup-editor .ag-rich-select-value {
    min-width: ${minFundColWidth}px;
  }

  /* Styling for subtotal/footer rows */
  .ag-row.ag-row-footer {
    background-color: ${({ theme }) => theme.colors.secondary[5]} !important;
    font-weight: 600;
    border-top: 1px solid ${({ theme }) => theme.colors.neutral[30]};
  }

  .ag-row.ag-row-footer .ag-cell {
    background-color: transparent;
  }

  /* Prevent editing of footer rows */
  .ag-row.ag-row-footer .ag-cell {
    pointer-events: none;
  }

  /* Hide checkboxes in footer rows */
  .ag-row.ag-row-footer .ag-selection-checkbox,
  .ag-row.ag-row-footer .ag-checkbox-input-wrapper {
    display: none !important;
  }
`;
